import type { DateGroup, TimeRange } from '@/utils/helpers/group-periods-by-same-date';

const formatSingleTimeRange = (dateStr: string, timeRange: TimeRange): string => {
  if (timeRange.isSameDay) {
    return `${timeRange.timeRange} (${dateStr})`;
  }

  const [startTime, endTime] = timeRange.timeRange.split(' - ');

  return `${startTime} (${dateStr}) - ${endTime} (${timeRange.endDateStr})`;
};

export const formatPeriodGroup = (group: DateGroup[]): string => {
  const first = group[0];
  const last = group[group.length - 1];

  if (group.length === 1 && first.timeRanges.length === 1) {
    return formatSingleTimeRange(first.dateStr, first.timeRanges[0]);
  }

  if (group.length === 1) {
    return `${first.timeRanges.map((range) => range.timeRange).join(', ')} (${first.dateStr})`;
  }

  return `${first.timeRanges.map((range) => range.timeRange).join(', ')} (${first.dateStr})\n(Repeats until ${last.dateStr})`;
};
